import React from 'react';
import './index.scss';

export default function FormFreeText({ children }) {
  return <div className="c-payment-journey-form-free-text">{children}</div>;
}
